import FinanceService from "../../services/FinanceService";
import AgentJobsService from "../../services/AgentJobsService";
import router from "../../router"; // Import the router instance

export default {
  namespaced: true,
  state() {
    return {
      finances: [],
      catalogue: [],
      // account: [],
      onlyForCust: false,
      financesStatuses: [{ name: "כרטסת", id: 2, count: "" }],
    };
  },
  mutations: {
    setFinances(state, finances) {
      state.finances = finances;
    },
    setCatalogue(state, catalogue) {
      state.catalogue = catalogue;
    },
    setAccount(state, account) {
      state.account = account;
    },
  },
  actions: {
    async getFinances(context, data) {
      try {
        var res = await FinanceService.getFinances(data);
        //after real data come
        context.commit("setFinances", res.data);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          // Navigate to the root route
          router.push("/");
        }
        console.error("Error fetching finances:", err);
      }
    },
    async getCatalogue({ commit }) {
      try {
        const res = await FinanceService.getCatalogue();
        commit("setCatalogue", res.data);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          // Navigate to the root route
          router.push("/");
        }
        console.error("Error fetching finances:", err);
      }
    },
    async getFinancePdf() {
      try {
        const res = await AgentJobsService.getFinancePdf();
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    },
    // async getAccount({ commit }) {
    //   try {
    //     const res = await FinanceService.getAccount();
    //     commit("setAccount", res.data);
    //   } catch (err) {
    //     if (err.response && err.response.status === 403) {
    //       // Navigate to the root route
    //       router.push('/');
    //     }
    //     console.error('Error fetching finances:', err);
    //   }

    // },
  },
  getters: {
    getFinances(state) {
      return state.finances;
    },
    getCatalogue(state) {
      return state.catalogue;
    },
    // getAccount(state) {
    //   return state.account;
    // },
    getFinancesStatuses(state) {
      return state.financesStatuses;
    },
    getFinancesCount(state) {
      return state.finances.length;
    },
  },
};
